<template>
  <div class='patient-wrapper'>
    <div class="row animated fadeIn step-container">
      <div class="col-md-8 offset-md-2 step-body">

        <h4 class="step-header">
          <div class='title'>{{$t('message.patient.title')}}</div>
          <a :href="export_csv" target="_blank" class="btn btn-success" style="margin-right: 20px;">Export csv</a>
          <button v-if="!showAddPanel" @click.prevent="enterCreateForm()" class="add-service btn btn-success">+ {{$t('action_message.add')}}</button>
          <button v-if="showAddPanel" @click.prevent="showAddPanel = !showAddPanel" class="add-service btn btn-info">{{$t('action_message.list')}}</button>
        </h4>

        <div v-if="!showAddPanel" class="patient-list-wrapper">
          <bs-input v-model='q' :placeholder="$t('message.patient.search_by')"></bs-input>
          <h3>{{$t('message.patient.patient_list')}}</h3>
          <div class='pagination'>
            <div><strong>{{$t('message.pagination.show')}}</strong> {{ paginator.from }} - {{ paginator.to }} <strong>{{$t('message.pagination.from')}}</strong> {{ paginator.total }} <strong>{{$t('message.pagination.rows')}}</strong></div>
            <a class='btn' @click="paginator.prev_page_url && reloadPatient(paginator.prev_page_url)" :class="{ enable: paginator.prev_page_url }">{{$t('message.pagination.prev')}}</a>
            <a class='btn' @click="paginator.next_page_url && reloadPatient(paginator.next_page_url)" :class="{ enable: paginator.next_page_url }">{{$t('message.pagination.next')}}</a>
          </div>

          <div class="patient-container-wrap">
            <div class="loading-wrap" v-show="searchLoading">
              <sync-loader size='10px' color='#20a8d8'></sync-loader>
            </div>
            <transition-group name='list' tag='div' v-if="patients.length > 0" >
              <div class="patients-container" v-for="(p, index) in filtered_patients" :key="p" @click="editPatient(p)">
                  <div class='btn'>
                    <i class='fa fa-male fa-lg' style='color: darkblue;' v-if="p.gender === 'm'"></i>
                    <i class='fa fa-female fa-lg' style='color: deeppink;' v-if="p.gender === 'f'"></i>
                  </div>
                  <div class='patients-content'>
                    <h6>{{ p.firstname }} {{ p.lastname }} {{ p.hn ? ' - ' + p.hn : '' }}</h6>
                    <!-- <div>{{ p.phone }}</div> -->
                  </div>
                <div class='patients-actions'>
                  <i class="fa fa-chevron-right" @click="editPatient(p)"></i>
                </div>
              </div>
            </transition-group>
            <h6 class="alert alert-warning" v-else>
              {{$t('message.patient.no_patient')}}
            </h6>
          </div>
        </div>

        <div v-show="showAddPanel" class='service-form'>
          <form @submit.prevent>
          <h6>{{$t('message.patient.required_info')}}</h6>
          <label>{{this.$t('message.patient.prefix')}}</label>
          <multiselect id="prefix" 
                    class="multi-select-form"
                    v-model="patient.prefix" 
                    :placeholder="this.$t('message.patient.prefix_placeholder')" 
                    :options="prefix_options" 
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
          <bs-input class="remove-margin-bottom" required :label="$t('message.patient.firstname')" v-model="patient.firstname" :placeholder="$t('message.patient.firstname')"></bs-input>
          <error-box :message="frmError.firstnameError"/>
          <div class="add-margin-bottom"/>
          <bs-input class="remove-margin-bottom" required :label="$t('message.patient.lastname')" v-model="patient.lastname" :placeholder="$t('message.patient.lastname')"></bs-input>
          <error-box :message="frmError.lastnameError"/>
          <div class="add-margin-bottom"/>

          <div class="form-divider"></div>

          <h6>{{$t('message.patient.gender')}}</h6>
          <div class="gender-select">
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="m" v-model="patient.gender"> <i class="fa fa-male fa-lg" aria-hidden="true"></i> {{$t('message.patient.male')}}
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="f" v-model="patient.gender"> <i class="fa fa-female fa-lg" aria-hidden="true"></i> {{$t('message.patient.female')}}
              </label>
            </div>
          </div>

          <div class="form-divider"></div>

          <label>{{$t('message.patient.phone_no')}}</label><br/>
          <input type='tel' id='phone' class='form-control'>
          <error-box :message="frmError.phoneError"/>

          <div class="form-divider"></div>

          <bs-input :label="$t('message.patient.hn')" v-model="patient.hn" :placeholder="$t('message.patient.hn')"></bs-input>
          <div class="form-divider"></div>

          <h6>{{$t('message.patient.contact')}}</h6>
          <bs-input :label="$t('message.patient.email')" type='email' v-model="patient.email" :placeholder="$t('message.patient.email')"></bs-input>
          <bs-input :label="$t('message.patient.address')" v-model="patient.b_address" :placeholder="$t('message.patient.address')"></bs-input>

          <div class="form-divider"></div>

          <h6>{{$t('message.patient.personal_info')}}</h6>
          <bs-input :label="$t('message.patient.id_card')" v-model="patient.id_card" :placeholder="$t('message.patient.id_card')"></bs-input>

          <div class="form-divider"></div>

          <label class='form-label'>{{$t('message.patient.birthdate')}}</label><br/>
          <flat-pickr v-model='patient.birthday'
                      id="fp"
                      :config="{enableTime: false, altInput: true, wrap: true, defaultDate: new Date('1986-01-01')}">
          </flat-pickr>
          <error-box :message="frmError.birthdayError"/>
          <br/>

          <bs-input :label="$t('message.patient.allergy')" v-model="patient.allergy" :placeholder="$t('message.patient.allergy')"></bs-input>
          <bs-input :label="$t('message.patient.diseases')" v-model="patient.diseases" :placeholder="$t('message.patient.diseases')"></bs-input>

          <div class="form-divider"></div>

          <h6>{{$t('message.patient.relative_info')}}</h6>
          <bs-input :label="$t('message.patient.relative_name')" v-model="patient.relative_name" :placeholder="$t('message.patient.relative_name')"></bs-input>
          <bs-input :label="$t('message.patient.relative_relation')" v-model="patient.relative_relation" :placeholder="$t('message.patient.relative_relation')"></bs-input>
          <bs-input :label="$t('message.patient.relative_phone')" v-model="patient.relative_phone" :placeholder="$t('message.patient.relative_phone')"></bs-input>

          <div class="row">
            <div class="col-12 form-group">
              <button class="btn btn-lg btn-close" @click="enterListView">{{$t('action_message.cancel')}}</button>
              <button class="btn btn-add btn-lg btn-success" @click="addPatient">{{ editMode ? $t('action_message.edit'): $t('action_message.add') }}</button>
              <div v-show='loading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div>
              <button v-if="editMode" class="btn btn-add btn-lg btn-danger remove-patient-action" @click="removePatient">{{$t('action_message.remove')}}</button>
            </div>
          </div>
          </form>

        </div>
      </div>
    </div>

    <sweet-modal icon="error" title="Error" ref='errorModal' overlay-theme="dark">
      {{sweetErrorMsg}}
    </sweet-modal>
  </div>
</template>

<script>

import { input as BsInput } from 'vue-strap'
import flatPickr from 'vue-flatpickr-component'
import Multiselect from 'vue-multiselect'
import jq from 'jquery'
import SyncLoader from 'vue-spinner/src/SyncLoader'
import ErrorBox from '@/components/ErrorMessageBox'
import { SweetModal } from 'sweet-modal-vue'

export default {
  components: {
    BsInput,
    flatPickr,
    SyncLoader,
    ErrorBox,
    Multiselect,
    SweetModal
  },
  props: {
    id: String
  },
  data () {
    let defaultPatient = {
      birthday: '',
      gender: 'm'
    }

    return {
      export_csv: this.$APP_CONFIG.api.domain + '/admin/api/v1/ehr_patient/export_csv',
      intl_phone: '',
      loading: false,
      searchLoading: false,
      editMode: false,
      showAddPanel: false,
      _searchQ: null, // timeout inst
      q: '',
      patients: [],
      defaultPatient,
      patient: Object.assign({}, defaultPatient),
      paginator: {},
      frmError: this.getFormError(),
      sweetErrorMsg: '',
      openEditMode: false,
      prefix_options: [
        {value: 'mrs', label: this.$t('message.patient.prefix_mrs')},
        {value: 'mr', label: this.$t('message.patient.prefix_mr')},
        {value: 'ms', label: this.$t('message.patient.prefix_ms')},
        {value: 'master', label: this.$t('message.patient.prefix_master')},
        {value: 'miss', label: this.$t('message.patient.prefix_miss')}
      ]
    }
  },
  watch: {
    q (v, old) {
      let debounchDelay = 500
      clearTimeout(this._searchQ)
      this._searchQ = setTimeout(() => {
        this.searchLoading = true
        this.$http.get(this.$APP_CONFIG.api.admin.patient(), {params: {
          search: v,
          clinic_id: this.$guser.user.clinic.id
        }}).then(res => {
          this.patients = res.body.data
          // update paginator
          Object.assign(this.paginator, {
            from: res.body.from,
            to: res.body.to,
            total: res.body.total,
            per_page: res.body.per_page,
            current_page: res.body.per_page,
            next_page_url: res.body.next_page_url,
            prev_page_url: res.body.prev_page_url
          })
          this.searchLoading = false
        }).catch(() => {
          this.searchLoading = false
        })
      }, debounchDelay) // delay
    }
  },
  computed: {
    filtered_patients () {
      return this.patients.sort((a, b) => a.created_at < b.created_at)
    }
  },
  methods: {
    reloadPatient (uri) {
      this.$http.get(uri || this.$APP_CONFIG.api.admin.patient(), {params: {
        clinic_id: this.$guser.user.clinic.id,
        search: this.q
      }}).then(res => {
        this.patients = res.body.data

        // update paginator
        Object.assign(this.paginator, {
          from: res.body.from,
          to: res.body.to,
          total: res.body.total,
          per_page: res.body.per_page,
          current_page: res.body.per_page,
          next_page_url: res.body.next_page_url,
          prev_page_url: res.body.prev_page_url
        })

        if (!this.openEditMode && this.id) {
          this.openEditMode = true
          let p = this.patients.find(pt => pt.id === +this.id)
          if (p) {
            this.editPatient(this.id)
          }
        }
      })
    },
    editPatient (patient) {
      this.patient = Object.assign({}, patient, {
        prefix: this.prefix_options.find(d => d.value === patient.prefix)
      })
      // this.patient.birthday = this.patient.birthday || ''
      jq('#phone').intlTelInput('setNumber', this.patient.phone)
      this.editMode = true
      this.showAddPanel = true
    },
    _updatePatient () {
      this.loading = true

      var patient = Object.assign({}, this.patient, {
        prefix: (this.patient.prefix) ? this.patient.prefix.value : null,
        clinic_id: this.$guser.user.clinic.id
      })

      this.$http.put(this.$APP_CONFIG.api.admin.patient_id(patient.id), patient, { credentials: true })
      .then(res => {
        this.reloadPatient()
        this.enterListView()
        this.patient = Object.assign({}, this.defaultPatient)
        this.loading = false
        jq('#phone').intlTelInput('setNumber', '')
      }).catch(res => {
        this.loading = false
        if (typeof res.body.error === 'string') {
          this.sweetErrorMsg = 'เบอร์โทรศัพท์, email หรือ เลขที่บัตรประชาชน นี้ได้ถูกใช้แล้วไม่สามารถสร้างซ้ำกันได้'
          this.$refs.errorModal.open()
        } else {
          let key = Object.keys(res.body.error)[0]
          this.sweetErrorMsg = res.body.error[key][0]
          this.$refs.errorModal.open()
        }
        if (res.body.error) {
          this.showFormFromError(res.body.error)
        }
      })
    },
    addPatient () {
      this.patient.phone = jq('#phone').intlTelInput('getNumber')
      if (this.editMode) {
        this._updatePatient()
      } else {
        this.loading = true
        var patient = Object.assign({}, this.patient, {
          prefix: (this.patient.prefix) ? this.patient.prefix.value : null,
          clinic_id: this.$guser.user.clinic.id
        })

        this.$http.post(this.$APP_CONFIG.api.admin.patient(), patient, { credentials: true }).then(res => {
          this.loading = false
          // create successful
          if (res.body.id) {
            this.reloadPatient()
            this.enterListView()
            this.patients.push(res.body)
            // reset patient
            this.patient = Object.assign({}, this.defaultPatient)
            jq('#phone').intlTelInput('setNumber', '')
            this.$toastr.success('Create new patient successful!')
          }
        }).catch(res => {
          this.loading = false
          if (typeof res.body.error === 'string') {
            this.sweetErrorMsg = 'เบอร์โทรศัพท์, email หรือ เลขที่บัตรประชาชน นี้ได้ถูกใช้แล้วไม่สามารถสร้างซ้ำกันได้'
            this.$refs.errorModal.open()
          } else {
            let key = Object.keys(res.body.error)[0]
            this.sweetErrorMsg = res.body.error[key][0]
            this.$refs.errorModal.open()
          }
          if (res.body.error) {
            this.showFormFromError(res.body.error)
          }
        })
      }
    },
    enterCreateForm () {
      this.showAddPanel = !this.showAddPanel
      this.editMode = false
      this.patient = Object.assign({}, this.defaultPatient)
    },
    enterListView () {
      this.showAddPanel = false
      this.editMode = false
    },
    async removePatient () {
      if (await this.$confirm('Are you sure')) {
        this.$http.delete(this.$APP_CONFIG.api.admin.patient_id(this.patient.id), { credentials: true }).then(res => {
          this.enterListView()
          let i = this.patients.findIndex(p => p.id === this.patient.id)
          if (i !== -1) {
            this.patients.splice(i, 1)
          }

          // reset patient
          this.patient = this.defaultPatient
        })
      }
    },
    clearFormError () {
      this.frmError = this.getFormError()
    },
    getFormError () {
      return {
        firstnameError: null,
        lastnameError: null,
        phoneError: null,
        birthdayError: null
      }
    },
    getFormDefaultError () {
      return {
        firstnameError: 'The firstname field is required.',
        lastnameError: 'The lastname field is required.',
        phoneError: 'The phone field is required.',
        birthdayError: 'The birthday field is required.'
      }
    },
    showFormFromError (error) {
      if (error) {
        this.frmError.firstnameError = this.getMessageFromError(error.firstname)
        this.frmError.lastnameError = this.getMessageFromError(error.lastname)
        this.frmError.phoneError = this.getMessageFromError(error.phone)
        this.frmError.birthdayError = this.getMessageFromError(error.birthday)
      }
    },
    getMessageFromError (errorObj) {
      var message = null
      if (errorObj && Array.isArray(errorObj)) {
        message = errorObj.join(' ')
      } else {
        message = errorObj
      }
      return message
    }
  },
  created () {
    this.reloadPatient()
  },
  mounted () {
    jq('#phone').intlTelInput({ nationalMode: true, initialCountry: 'th', utilsScript: '/static/utils.js' })
  }
}
/* eslint-enable */
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang='scss'>
@import "../../assets/base_container";
@import "../../assets/base_pagination";
.patient-wrapper {
  .patient-container-wrap{
    position: relative;
  }
  .loading-wrap{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.7);
    text-align: center;
    .v-spinner{
      margin-top: 20px;
    }
  }
  .patients-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #fafafa;
    border: 1px solid #ddd;
    margin-bottom: 0.5em;
    border-radius: 5px;
    
    h6 {
      margin: 0;
    }
    
    .patients-content {
      flex: 2; 
      padding: 0.5rem;
      border-right: 1px solid #ddd;
    }

    .patients-actions {
      padding: 1em;
    }
  }

  .remove-patient-action {
    float: right;
  }

  .list-enter-active, .list-leave-active {
      transition: all 0.3s;
  }
  .list-enter, .list-leave-to /* .list-leave-active for <2.1.8 */ {
      opacity: 0;
      transform: translateX(10px);
  }

  .step-header {
    display: flex;
    justify-content: center;
    align-items: center;
    .title {
      flex: 1;
    }
  }

  .flatpickr-input {
    width: 150px;
    background-color: white !important;
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// Patient.vue?72a86c76